var _style, _path, _g, _defs, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarrots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#AA1917;}\n\t.st1{fill:#76B155;}\n\t.st2{fill:#F08F16;}\n\t.st3{clip-path:url(#SVGID_2_);fill:#D27611;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.63,182.83c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C29.33,148.54,63.94,182.83,106.63,182.83"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M142.2,83.15c8.62-5.18,10.75-20.3,9.03-18.57c1.73-1.73-13.8,0-18.97,8.63c0-3.45-3.45-17.25-8.62-5.17 c-5.18,12.07-3.45,13.8-3.45,17.25c0,3.45,6.9,3.45,6.9,3.45s-0.3,6.6,3.15,6.6c3.45,0,4.87,1.42,16.94-3.75 C159.24,86.4,145.65,83.15,142.2,83.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M121.04,118.92c-18.58,18.58-49.16,31.91-53.47,27.6c-4.31-4.31,9.02-34.89,27.6-53.47 c18.58-18.58,28.13-18.45,36.23-10.35C139.48,90.79,139.61,100.34,121.04,118.92"
  }))), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M95.16,93.04c-18.58,18.58-31.91,49.16-27.6,53.47c4.31,4.31,34.9-9.02,53.47-27.6 c18.58-18.58,18.45-28.13,10.35-36.22c-3.24-3.24-6.71-5.2-10.9-5.2C114.2,77.49,106.31,81.9,95.16,93.04"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M105.88,137.2c-11.18-5.59-16.77-11.18-19.56-13.97c-2.8-2.8,2.8,13.97,13.98,19.56 C111.47,148.38,105.88,137.2,105.88,137.2 M127.84,117.68c-11.18-5.59-16.77-11.18-19.56-13.97c-2.79-2.8,2.8,13.97,13.98,19.56 C133.43,128.86,127.84,117.68,127.84,117.68 M87.47,97c5.59,11.18,11.18,16.77,13.97,19.57c2.8,2.79-13.97-2.8-19.56-13.98 C76.29,91.42,87.47,97.01,87.47,97 M105.73,77.32c5.59,11.18,11.18,16.77,13.98,19.56c2.79,2.79-13.98-2.79-19.56-13.98 C94.55,71.73,105.73,77.32,105.73,77.32"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarrots);
export default __webpack_public_path__ + "static/media/Carrots.eb1d44e57f961124fc2319fd1b18efe4.svg";
export { ForwardRef as ReactComponent };